import styled from '@emotion/styled';
import { nafColor } from '@nafcore/theme';
import { borderRadius, spacing } from '@naf/theme';

export const HoverWrap = styled.span`
  background-size: 0 2px;
  background-position: 0 100%;
  background-image: linear-gradient(90deg, ${nafColor.signature.yellow}, ${nafColor.signature.yellow});
  background-repeat: no-repeat;
  transition: background-size 0.3s ease;
  text-decoration: none;
  display: inline;
  width: fit-content;
  margin-top: -${spacing.space8};
`;

export const InnerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-self: stretch;
`;

export const VehicleBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  background-color: ${nafColor.neutral.neutral1};
  border-radius: ${borderRadius.L};
  text-decoration: none;
  width: 100%;
  min-width: 240px;
  min-height: 121px;
  justify-content: center;

  &:hover,
  &:active,
  &:visited {
    color: ${nafColor.signature.black};
  }

  &:hover {
    ${HoverWrap} {
      background-size: 100% 2px;
    }
  }
`;

export const VehicleBoxContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 ${spacing.space16};
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.space4};
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${spacing.space8};
`;

export const LineSeparator = styled.div`
  width: 3px;
  background-color: ${nafColor.signature.yellow};
  align-self: stretch;
  margin: 0 0 0 ${spacing.space16};
`;
